import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import _isFunction from "lodash/isFunction";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.number.constructor.js";
import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Paper, Form, Row, Col, Input, Button, DateTimePicker, Dropdown, CreditData, CreditContactForm, CheckboxSwitch, showError } from 'components';
import { useUser } from 'components/shared';
import { getCurrencyConfig, positiveDoublePattern, showApiError } from 'utils';
import { dateFormat, loanPurposeNameSelect, loanAbsorptionNameSelect, CREDIT_PAYMENT_TYPE } from 'enums';
import { createCredit, refinanceCredit, previewCredit, getAllRiskLevels, getOffice } from 'services';
import { jsx as ___EmotionJSX } from "@emotion/react";

var loanDurationOptions = _toConsumableArray(Array(36)).map(function (e, i) {
  return {
    label: "".concat(i + 1, " \u043C\u0435\u0441\u0435\u0446").concat(i + 1 === 1 ? '' : 'а'),
    value: i + 1
  };
});

var homeVisitOptions = [{
  label: 'Да',
  value: 1
}, {
  label: 'Не',
  value: 0
}];

var sectionStyle = function sectionStyle(theme) {
  return {
    padding: '1.6em 0',
    borderBottom: "1px solid ".concat(theme.gray100),
    '&:first-of-type': {
      paddingTop: 0
    },
    '&:last-of-type': {
      borderBottom: 'none',
      paddingBottom: 0
    }
  };
};

var sectionTitle = function sectionTitle(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '0.6em',
    marginBottom: '1.4em',
    '& i': {
      fontSize: '1.6rem',
      color: theme.primary
    },
    '& span': {
      fontSize: '1.3rem',
      fontWeight: 600,
      color: theme.gray700,
      textTransform: 'uppercase',
      letterSpacing: '0.04em'
    }
  };
};

var CreditApplyForm = function CreditApplyForm(_ref) {
  var _userInfo$currentOffi2, _ref4, _initialCreditData$am, _initialCreditData$da, _initialCreditData$lo, _userInfo$currentOffi3, _getCurrencyConfig, _userInfo$currentOffi4;

  var borrower = _ref.borrower,
      credit = _ref.credit,
      refinanceData = _ref.refinanceData,
      onBack = _ref.onBack,
      onNext = _ref.onNext,
      onCreditChange = _ref.onCreditChange,
      isCalculator = _ref.isCalculator,
      initialCreditData = _ref.initialCreditData;

  var _useUser = useUser(),
      userInfo = _useUser.userInfo,
      tenant = _useUser.tenant;

  var isSeparatePaymentTenant = (tenant === null || tenant === void 0 ? void 0 : tenant.credit_payment_type) === CREDIT_PAYMENT_TYPE.home_visit_fee_separate_payment;
  var formDataRef = useRef();
  var formSubmitRef = useRef();
  var autoSubmittedRef = useRef(false);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      riskLevels = _useState2[0],
      setRiskLevels = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      partners = _useState4[0],
      setPartners = _useState4[1];

  var _useState5 = useState(initialCreditData === null || initialCreditData === void 0 ? void 0 : initialCreditData.home_visit_contract),
      _useState6 = _slicedToArray(_useState5, 2),
      homeVisitContract = _useState6[0],
      setHomeVisitContract = _useState6[1];

  useEffect(function () {
    fetchRiskLevels();
  }, []);
  useEffect(function () {
    if (initialCreditData && formSubmitRef.current && !autoSubmittedRef.current) {
      autoSubmittedRef.current = true;
      formSubmitRef.current();
    }
  }, [initialCreditData, riskLevels]);
  useEffect(function () {
    var _userInfo$currentOffi;

    if (isSeparatePaymentTenant && userInfo !== null && userInfo !== void 0 && (_userInfo$currentOffi = userInfo.currentOffice) !== null && _userInfo$currentOffi !== void 0 && _userInfo$currentOffi.id) fetchOfficePartners(userInfo.currentOffice.id);
  }, [isSeparatePaymentTenant, userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$currentOffi2 = userInfo.currentOffice) === null || _userInfo$currentOffi2 === void 0 ? void 0 : _userInfo$currentOffi2.id]);

  var fetchRiskLevels = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getAllRiskLeve, _yield$getAllRiskLeve2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAllRiskLevels();

            case 2:
              _yield$getAllRiskLeve = _context.sent;
              _yield$getAllRiskLeve2 = _slicedToArray(_yield$getAllRiskLeve, 2);
              res = _yield$getAllRiskLeve2[0];
              err = _yield$getAllRiskLeve2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setRiskLevels(res);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchRiskLevels() {
      return _ref2.apply(this, arguments);
    };
  }();

  var fetchOfficePartners = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(officeId) {
      var _yield$getOffice, _yield$getOffice2, res, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getOffice(officeId);

            case 2:
              _yield$getOffice = _context2.sent;
              _yield$getOffice2 = _slicedToArray(_yield$getOffice, 2);
              res = _yield$getOffice2[0];
              err = _yield$getOffice2[1];

              if (!err) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 8:
              setPartners(res === null || res === void 0 ? void 0 : res.partners);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchOfficePartners(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var initialFormData = {
    amount: (_ref4 = (_initialCreditData$am = initialCreditData === null || initialCreditData === void 0 ? void 0 : initialCreditData.amount) !== null && _initialCreditData$am !== void 0 ? _initialCreditData$am : refinanceData === null || refinanceData === void 0 ? void 0 : refinanceData.amount) !== null && _ref4 !== void 0 ? _ref4 : '',
    date: (_initialCreditData$da = initialCreditData === null || initialCreditData === void 0 ? void 0 : initialCreditData.date) !== null && _initialCreditData$da !== void 0 ? _initialCreditData$da : moment(new Date()).format(dateFormat),
    loan_absorption: (_initialCreditData$lo = initialCreditData === null || initialCreditData === void 0 ? void 0 : initialCreditData.loan_absorption) !== null && _initialCreditData$lo !== void 0 ? _initialCreditData$lo : 2,
    period_months: initialCreditData === null || initialCreditData === void 0 ? void 0 : initialCreditData.period_months,
    risk_level: initialCreditData === null || initialCreditData === void 0 ? void 0 : initialCreditData.risk_level,
    loan_purpose: initialCreditData === null || initialCreditData === void 0 ? void 0 : initialCreditData.loan_purpose,
    home_visit_contract: initialCreditData === null || initialCreditData === void 0 ? void 0 : initialCreditData.home_visit_contract,
    partner_id: initialCreditData === null || initialCreditData === void 0 ? void 0 : initialCreditData.partner_id,
    office_id: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$currentOffi3 = userInfo.currentOffice) === null || _userInfo$currentOffi3 === void 0 ? void 0 : _userInfo$currentOffi3.id,
    borrower_id: borrower === null || borrower === void 0 ? void 0 : borrower.id,
    currency: (_getCurrencyConfig = getCurrencyConfig()) === null || _getCurrencyConfig === void 0 ? void 0 : _getCurrencyConfig.defaultCurrency,
    franchisee_id: (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$currentOffi4 = userInfo.currentOffice) === null || _userInfo$currentOffi4 === void 0 ? void 0 : _userInfo$currentOffi4.franchisee_id) || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.franchisee_id)
  };

  var handleSubmit = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref5) {
      var values, _yield$previewCredit, _yield$previewCredit2, res, err;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              values = _ref5.values;

              if (!(refinanceData && Number(values === null || values === void 0 ? void 0 : values.amount) < Number(refinanceData === null || refinanceData === void 0 ? void 0 : refinanceData.amount))) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return", showError('Въведента сума на кредита не е достатъчна за рефинансиране!'));

            case 3:
              _context3.next = 5;
              return previewCredit(_objectSpread(_objectSpread(_objectSpread({}, values), refinanceData && {
                refinance_credit_id: refinanceData === null || refinanceData === void 0 ? void 0 : refinanceData.creditId
              }), {}, {
                is_calculator: isCalculator
              }));

            case 5:
              _yield$previewCredit = _context3.sent;
              _yield$previewCredit2 = _slicedToArray(_yield$previewCredit, 2);
              res = _yield$previewCredit2[0];
              err = _yield$previewCredit2[1];

              if (!err) {
                _context3.next = 11;
                break;
              }

              return _context3.abrupt("return", showApiError(err));

            case 11:
              formDataRef.current = values;
              _isFunction(onCreditChange) && onCreditChange(res, values);
              return _context3.abrupt("return", true);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleSubmit(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();

  var handleNext = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(values) {
      var _formDataRef$current;

      var hasGuarantor, method, _yield$method, _yield$method2, res, err;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              hasGuarantor = (_formDataRef$current = formDataRef.current) === null || _formDataRef$current === void 0 ? void 0 : _formDataRef$current.hasGuarantor;
              method = refinanceData ? refinanceCredit : createCredit;
              _context4.next = 4;
              return method(_objectSpread(_objectSpread(_objectSpread({}, formDataRef.current), values), refinanceData && {
                refinance_credit_id: refinanceData === null || refinanceData === void 0 ? void 0 : refinanceData.creditId
              }));

            case 4:
              _yield$method = _context4.sent;
              _yield$method2 = _slicedToArray(_yield$method, 2);
              res = _yield$method2[0];
              err = _yield$method2[1];

              if (!err) {
                _context4.next = 10;
                break;
              }

              return _context4.abrupt("return", showApiError(err));

            case 10:
              _isFunction(onCreditChange) && onCreditChange(res);
              _isFunction(onNext) && onNext(!hasGuarantor ? 6 : null);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleNext(_x3) {
      return _ref7.apply(this, arguments);
    };
  }();

  var handleGuarantor = function handleGuarantor(value) {
    formDataRef.current = _objectSpread(_objectSpread({}, formDataRef.current), {}, {
      hasGuarantor: value
    });
  };

  var handleBack = function handleBack() {
    formDataRef.current = null;
    _isFunction(onCreditChange) && onCreditChange();
    _isFunction(onBack) && onBack();
  };

  var handleFormChange = function handleFormChange(formId, _ref8) {
    var values = _ref8.values;
    if (formId === 'home_visit_contract') setHomeVisitContract(values === null || values === void 0 ? void 0 : values.home_visit_contract);
  };

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Paper, {
    header: "\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438 \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0430",
    margin: "0 0 2em 0"
  }, ___EmotionJSX(Form, {
    onSubmit: handleSubmit,
    values: initialFormData,
    onChange: handleFormChange
  }, ___EmotionJSX("section", {
    css: sectionStyle
  }, ___EmotionJSX("div", {
    css: sectionTitle
  }, ___EmotionJSX("i", {
    className: "las la-calculator"
  }), ___EmotionJSX("span", null, "\u041E\u0441\u043D\u043E\u0432\u043D\u0438 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438")), ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Input, _extends({
    pattern: positiveDoublePattern,
    number: true,
    formId: "amount",
    label: "\u0421\u0443\u043C\u0430"
  }, refinanceData && {
    helpText: "| \u041C\u0438\u043D. \u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442: ".concat(refinanceData === null || refinanceData === void 0 ? void 0 : refinanceData.amount, " ").concat(refinanceData === null || refinanceData === void 0 ? void 0 : refinanceData.currency)
  }, {
    required: true,
    inputProps: {
      inputMode: 'decimal',
      'data-field': 'credit-amount'
    }
  }))), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Dropdown, {
    required: true,
    formId: "period_months",
    label: "\u0421\u0440\u043E\u043A \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0430",
    options: loanDurationOptions,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(DateTimePicker, {
    required: true,
    formId: "date",
    label: "\u041D\u0430\u0447\u0430\u043B\u043E \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0430",
    timeFormat: false,
    dateFormat: dateFormat,
    inputProps: {
      placeholder: 'Начало на кредита',
      'data-field': 'credit-start-date'
    }
  })))), ___EmotionJSX("section", {
    css: sectionStyle
  }, ___EmotionJSX("div", {
    css: sectionTitle
  }, ___EmotionJSX("i", {
    className: "las la-shield-alt"
  }), ___EmotionJSX("span", null, "\u0420\u0438\u0441\u043A \u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F")), ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Dropdown, {
    required: true,
    formId: "risk_level",
    label: "\u041D\u0438\u0432\u043E \u043D\u0430 \u0440\u0438\u0441\u043A",
    options: riskLevels,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Dropdown, {
    noClear: true,
    required: true,
    formId: "loan_absorption",
    label: "\u041D\u0430\u0447\u0438\u043D \u043D\u0430 \u0443\u0441\u0432\u043E\u044F\u0432\u0430\u043D\u0435",
    options: loanAbsorptionNameSelect,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Dropdown, {
    formId: "loan_purpose",
    label: "\u0426\u0435\u043B \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0430",
    options: loanPurposeNameSelect,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Dropdown, {
    required: true,
    formId: "home_visit_contract",
    label: "\u0414\u043E\u043C\u0430\u0448\u043D\u043E \u043F\u043E\u0441\u0435\u0449\u0435\u043D\u0438\u0435",
    options: homeVisitOptions,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })), isSeparatePaymentTenant && homeVisitContract === 1 && ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Dropdown, {
    required: true,
    formId: "partner_id",
    label: "\u041F\u0430\u0440\u0442\u043D\u044C\u043E\u0440",
    displayKey: "name",
    uniqueKey: "id",
    options: partners,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.id;
    }
  })))), ___EmotionJSX(Row, {
    horizontalGap: 8,
    margin: "1.6em 0 0 0"
  }, ___EmotionJSX(Col, {
    displayFlex: true,
    md: 12,
    justify: "flex-end"
  }, function (_ref9) {
    var onSubmit = _ref9.onSubmit;
    formSubmitRef.current = onSubmit;
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Button, {
      type: "secondary",
      onClick: handleBack,
      margin: "0 1em 0 0"
    }, "\u041D\u0430\u0437\u0430\u0434"), ___EmotionJSX(Button, {
      onClick: onSubmit
    }, ___EmotionJSX("i", {
      className: "las la-calculator",
      style: {
        marginRight: 6
      }
    }), "\u0418\u0437\u0447\u0438\u0441\u043B\u0438 \u043A\u0440\u0435\u0434\u0438\u0442\u0430"));
  })))), credit && ___EmotionJSX(Paper, {
    header: "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0437\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0430",
    margin: "0 0 2em 0"
  }, ___EmotionJSX(CreditData, {
    credit: credit,
    isRefinance: !!refinanceData,
    showMergedPlan: isCalculator
  }), borrower && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(CheckboxSwitch, {
    fluid: true,
    label: "\u041F\u043E\u0440\u044A\u0447\u0438\u0442\u0435\u043B",
    onChange: handleGuarantor
  }), ___EmotionJSX(CreditContactForm, {
    borrowerIdNumber: borrower === null || borrower === void 0 ? void 0 : borrower.id_number,
    onSubmit: handleNext
  }))));
};

CreditApplyForm.propTypes = {
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  onCreditChange: PropTypes.func,
  borrower: PropTypes.object,
  credit: PropTypes.object,
  refinanceData: PropTypes.object,
  isCalculator: PropTypes.bool,
  initialCreditData: PropTypes.object
};
export default CreditApplyForm;